// @flow
import { createAction } from 'redux-actions';
import type { ChannelStatsResponse } from './types.js.flow';

type ChannelStatsRequestPayload = {
  clientId: Id,
  channelName: string,
  worklist?: boolean,
};

// Channel Stats
export const requestChannelStats = createAction(
  '@channels/CHANNEL_STATS_REQUEST',
  (payload: ChannelStatsRequestPayload) => payload
);

export const requestBrandEngageChannelStats = createAction(
  '@channels/CHANNEL_STATS_BRAND_REQUEST',
  (payload: ChannelStatsRequestPayload & { brandEngageType: string }) => payload
);

export const receiveChannelStats = createAction(
  '@channels/CHANNEL_STATS_RESPONSE',
  (channelStats: ChannelStatsResponse, meta: ChannelStatsRequestPayload) =>
    channelStats,
  (channelStats: ChannelStatsResponse, meta: ChannelStatsRequestPayload) => meta
);



// WEBPACK FOOTER //
// ./src/containers/channels/channelStatsActions.js